import { SelectReservationOrNowModal } from "components/organisms/HalfModal/SelectReservationOrNowModal";
import { orderState } from "lib/recoil/atoms";
import { useModal } from "mui-modal-provider";
import { useRouter } from "next/router";
import { useRecoilState } from "recoil";
import TalkIcon from "shared/assets/icons/talk.svg";
import TelephoneIcon from "shared/assets/icons/telephone.svg";
import { Button } from "shared/components/atoms/Button";
import { NavigationBase } from "shared/components/atoms/Navigation";
import { css } from "styled-components";
import tw from "twin.macro";
import { Paths } from "utils/routes";
import { usePrice } from "shared/features/shared/usePrice";
import { useFortuneTeller, useMe } from "repositories/hooks";
import { useCallbackWithAuth } from "features/shared/hooks/useCallbackWithAuth";
import { useFeatureFlags } from "features/shared/hooks/useFeatureFlags";
import { useMaintenanceModal } from "shared/features/Menu/hooks/useMaintenanceModal";
import { Tooltip } from "shared/components/atoms/Tooltip";
import { RestrictedTelFortuneModal } from "features/menu/components/RestrictedTelFortuneModal";
import { useCampaign } from "features/shared/hooks/useCampaign";

const buttonCss = [
  tw`bg-gradient-theme-to-l w-full h-14 rounded-lg even:ml-2`,
  css({ wordBreak: "keep-all" }),
];

const buttonLabelCss = tw`font-semibold text-center text-[13px] tracking-[.38px] text-white`;

const priceCss = tw`font-normal text-2xs mt-2 tracking-[.29px]`;

export const FortuneTellerNavigation = () => {
  const { query } = useRouter();
  const { fortuneTeller } = useFortuneTeller(query.id);
  const { me } = useMe();
  const { isTelFortuneDisabled } = useFeatureFlags();

  const { push } = useRouter();
  const { showModal } = useModal();
  const [recoilState, setRecoilState] = useRecoilState(orderState);
  const { showModal: showMaintenanceModal } = useMaintenanceModal();

  const { getMinimumChatMenuPrice, getMinimumTelMenuPrice } = usePrice();
  const { showCampaignPromotion, coupon } = useCampaign({
    fortuneTellerId: fortuneTeller?.id,
  });

  const onPressChatButton = useCallbackWithAuth(async () => {
    await push(Paths.order.chat.menu(fortuneTeller?.id));
  });

  const onPressTelButton = useCallbackWithAuth(() => {
    if (me.restrictedTelFortune) {
      showModal(RestrictedTelFortuneModal);
      return;
    }

    showModal(SelectReservationOrNowModal, {
      onSubmit: async (fromNow: boolean) => {
        if (fromNow && isTelFortuneDisabled) {
          showMaintenanceModal();
        } else {
          setRecoilState({
            ...recoilState,
            _type: "tel",
            fromNow,
          });
          await push(Paths.order.tel.menu(fortuneTeller?.id));
        }
      },
      fortuneTeller,
    });
  });

  const havePublishedChat = fortuneTeller?.havePublishedChat;
  const havePublishedTel = fortuneTeller?.havePublishedTel;
  const chatAcceptFlag = fortuneTeller?.chatAcceptFlag;
  const telAcceptFlag = fortuneTeller?.telAcceptFlag;
  const isBusy = fortuneTeller?.isBusy;
  const isChatEnabled = !isBusy && havePublishedChat && chatAcceptFlag;
  const isTelEnabled = havePublishedTel && telAcceptFlag;
  const isCanOrder = isChatEnabled || isTelEnabled;

  return (
    <NavigationBase
      tw="h-20 items-center justify-evenly py-3 px-5"
      css={fortuneTeller && !isCanOrder && tw`h-0 p-0 border-none`}
    >
      {isChatEnabled && (
        <Button onClick={onPressChatButton} css={buttonCss}>
          <TalkIcon
            tw="mr-1.5"
            width={21.81}
            height={20.42}
            viewBox="0, 0, 10.9, 10.21"
          />
          <div css={buttonLabelCss}>
            チャットで鑑定
            <div css={priceCss}>
              {getMinimumChatMenuPrice(fortuneTeller)}円~
            </div>
          </div>
        </Button>
      )}
      {isTelEnabled && (
        <Button tw="relative" onClick={onPressTelButton} css={buttonCss}>
          {showCampaignPromotion && (
            <Tooltip
              tw="absolute -top-8 right-7"
              color="#FE4FD0"
              triangleProps={{
                direction: "bottom",
                width: 18,
                height: 5,
                style: { position: "absolute", bottom: -10, right: 48 },
              }}
            >
              お持ちのクーポン利用で最大{coupon?.discountAmount || 2000}
              円分無料✨
            </Tooltip>
          )}
          <TelephoneIcon
            tw="mr-1.5"
            width={20.87}
            height={20.81}
            viewBox="0, 0, 10.45, 10.4"
          />
          <div css={buttonLabelCss}>
            電話で鑑定
            <div css={priceCss}>{getMinimumTelMenuPrice(fortuneTeller)}円~</div>
          </div>
        </Button>
      )}
    </NavigationBase>
  );
};
